import EnumInput from './EnumInput';

const propertyInputs = {
  enum: EnumInput
}

export default propertyInputs